export const SET_DOMEX_STEP = "SET_DOMEX_STEP";
export const SET_DOMEX_PHASE = "SET_DOMEX_PHASE";
export const SET_DOMEX_SUBMISSION_REF = "SET_DOMEX_SUBMISSION_REF";
export const SET_DOMEX_SAME_AS_SUBSCRIBER = "SET_DOMEX_SAME_AS_SUBSCRIBER";
export const SET_DOMEX_ACTIVE_BENEFICIARY = "SET_DOMEX_ACTIVE_BENEFICIARY";

// Champs
export const SET_DOMEX_CONTRACT_FIELD = "SET_DOMEX_CONTRACT_FIELD";
export const SET_DOMEX_PERSON_FIELD = "SET_DOMEX_PERSON_FIELD"; // subscriber | insured
export const SET_DOMEX_BENEFICIARY_FIELD = "SET_DOMEX_BENEFICIARY_FIELD";
export const SET_DOMEX_CONSENT = "SET_DOMEX_CONSENT";

// Bénéficiaires
export const ADD_DOMEX_BENEFICIARY = "ADD_DOMEX_BENEFICIARY";
export const REMOVE_DOMEX_BENEFICIARY = "REMOVE_DOMEX_BENEFICIARY";

// Sync souscripteur → assuré
export const COPY_SUBSCRIBER_TO_INSURED = "COPY_SUBSCRIBER_TO_INSURED";

// Fichiers
export const SET_DOMEX_FILE = "SET_DOMEX_FILE";

// Erreurs
export const SET_DOMEX_ERRORS = "SET_DOMEX_ERRORS";
export const SET_DOMEX_ERROR = "SET_DOMEX_ERROR";
export const CLEAR_DOMEX_ERRORS = "CLEAR_DOMEX_ERRORS";

// Loading
export const SET_DOMEX_LOADING = "SET_DOMEX_LOADING";

// Reset
export const RESET_DOMEX = "RESET_DOMEX";
